import { motion } from "framer-motion";
import { Award, BookOpen, Scale } from "lucide-react";

const HIGHLIGHTS = [
  { icon: Award, label: "ACCA Certified Professional" },
  { icon: Scale, label: "Licensed Legal Advocate" },
  { icon: BookOpen, label: "International Standards of Excellence" },
];

export default function FounderDesk() {
  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="py-24 md:py-32 bg-[#131821] relative overflow-hidden"
    >
      {/* Decorative accent */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#D4AF37]/[0.02] rounded-full blur-3xl" />

      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Image */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="relative aspect-[4/5] max-w-md mx-auto lg:mx-0">
              <img
                src="https://customer-assets.emergentagent.com/job_tax-compliance-hub-30/artifacts/gxvyhpch_WhatsApp%20Image%202026-04-01%20at%203.40.03%20PM.jpeg"
                alt="Sagar Tiwari - Founder"
                className="w-full h-full object-cover object-top"
                data-testid="founder-image"
              />
              {/* Gold frame accent */}
              <div className="absolute -bottom-4 -right-4 w-full h-full border border-[#D4AF37]/20 -z-10" />
            </div>
          </motion.div>

          {/* Right: Content */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
          >
            <p className="font-work text-sm font-semibold tracking-[0.2em] text-[#D4AF37] uppercase mb-4">
              Founder's Desk
            </p>

            <h2 className="font-outfit text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-white mb-6">
              Excellence in Every{" "}
              <span className="text-[#D4AF37]">Endeavour</span>
            </h2>

            <p className="font-work text-base md:text-lg text-[#94A3B8] leading-relaxed mb-6">
              AVS Associates & Co is a premier taxation consultancy firm led by{" "}
              <span className="text-white font-medium">(Adv.) Sagar Tiwari (ACCA)</span>,
              providing comprehensive financial, audit, and compliance services
              with international standards of excellence.
            </p>

            <p className="font-work text-base text-[#94A3B8] leading-relaxed mb-8">
              Our commitment to client-centric approach drives everything we do.
              We continuously innovate and adapt to provide the highest quality services,
              ensuring your business thrives in a dynamic regulatory environment.
            </p>

            {/* Highlights */}
            <div className="space-y-4 mb-10">
              {HIGHLIGHTS.map((h, i) => {
                const Icon = h.icon;
                return (
                  <div
                    key={i}
                    data-testid={`founder-highlight-${i}`}
                    className="flex items-center gap-4"
                  >
                    <div className="w-10 h-10 bg-[#D4AF37]/10 flex items-center justify-center shrink-0">
                      <Icon size={18} className="text-[#D4AF37]" />
                    </div>
                    <span className="font-work text-sm text-white tracking-wide">
                      {h.label}
                    </span>
                  </div>
                );
              })}
            </div>

            {/* Founder signature */}
            <div className="border-t border-white/5 pt-6">
              <p className="font-outfit text-lg text-white font-medium">
                Sagar Tiwari
              </p>
              <p className="font-work text-sm text-[#D4AF37] tracking-wide">
                Founder & Principal | ACCA | ADV
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
